import React from "react";
import AutoLoadingButton from "@/components/AutoLoadingButton";
import { FD_BASE_URL } from "@/config";
import {
    payShopCustomizationOrder,
    payShopCustomizationOrderBySupplier,
    syncUnpaidCustomizationAddedValueOrders,
} from "@/services/api/customization";
import { getSETokenFromQn } from "@qn/services/api/getToken";
import { message, Modal } from "antd";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";

interface CustomizationInfoUnpaidProps {
    isSupplierShop: boolean;

    shopId: number;
}

const CustomizationInfoUnpaid: React.FC<CustomizationInfoUnpaidProps> = function (props) {
    const { isSupplierShop, shopId } = props;

    const orderManagementStore = useOrderManagementStore();

    // 供货商视角
    if (isSupplierShop) {
        const payOrderBySupplier = async () => {
            const result = await payShopCustomizationOrderBySupplier(shopId);

            if (result.status === "COMPLETED") {
                const subResults = result.results.filter((result) => !result.successful);

                if (!subResults.length) {
                    message.success("获取成功");
                } else {
                    Modal.error({
                        title: "手动获取失败，请联系代理商充值",
                        content: subResults.map((it) => `${it.orderNo}:${it.errorMsg}`).join("、"),
                    });
                }

                orderManagementStore.fetchOrders(shopId);
            }

            if (result.status === "ERROR") {
                const subResults = result.results.filter((result) => !result.successful);

                Modal.error({
                    title: "支付失败",
                    content: subResults.map((it) => `${it.orderNo}:${it.errorMsg}`).join("、"),
                });
            }
        };

        return (
            <div>
                <p className="text-error mb5">暂时无法查看</p>

                <div>
                    可能原因1: 未自动获取，请点击
                    <AutoLoadingButton className="text-small" type="link" onClick={payOrderBySupplier}>
                        手动获取
                    </AutoLoadingButton>
                </div>

                <div>可能原因2: 代理商点数余额不足，请联系代理商处理</div>
            </div>
        );
    }
    // 普通商家/代理商视角
    else {
        const payOrder = async () => {
            const result = await payShopCustomizationOrder(shopId);

            if (result.status === "COMPLETED") {
                message.success("支付完成");

                const subResults = result.results.filter((result) => !result.successful);

                if (!subResults.length) {
                    message.success("支付完成");
                } else {
                    Modal.error({
                        title: "部分支付失败",
                        content: subResults.map((it) => `${it.orderNo}:${it.errorMsg}`).join("、"),
                    });
                }

                orderManagementStore.fetchOrders(shopId);
            }

            if (result.status === "ERROR") {
                const subResults = result.results.filter((result) => !result.successful);

                Modal.error({
                    title: "支付失败",
                    content: subResults.map((it) => `${it.orderNo}:${it.errorMsg}`).join("、"),
                });
            }
        };

        return (
            <div>
                <p className="text-error mb5">暂时无法查看</p>

                <div>
                    可能原因1: 未自动扣点,请点击
                    <AutoLoadingButton className="text-small" type="link" onClick={payOrder}>
                        手动扣点
                    </AutoLoadingButton>
                </div>

                <div>
                    可能原因2: 点数余额不足,请点击
                    <AutoLoadingButton
                        className="text-small"
                        type="link"
                        onClick={async (e) => {
                            e.preventDefault();

                            if (import.meta.env.VITE_IS_QN) {
                                const token = await getSETokenFromQn();

                                const a = document.createElement("a");

                                a.href = `${FD_BASE_URL}/customization/main/pay?_token_=${token}`;

                                a.target = "_blank";

                                a.click();
                            } else {
                                window.open("/customization/main/pay");
                            }

                            Modal.info({
                                title: "提示",
                                content: "是否支付完成",
                                okCancel: true,
                                okText: "支付完成？",
                                async onOk() {
                                    await syncUnpaidCustomizationAddedValueOrders();

                                    await payOrder();
                                },
                            });
                        }}
                    >
                        前往充值
                    </AutoLoadingButton>
                </div>
            </div>
        );
    }
};

export default observer(CustomizationInfoUnpaid);
